import defaults from "superagent-defaults";
import store from "../reducers/store";
import { setLoading } from "../actions/spinner";
import intercept from "superagent-intercept";
import history from "../../utils/history";
import { notFound, serverError } from "./urls";
import * as log from "./log";
import { getPartnerUrl } from "../config/cabinet";
import prefix from "superagent-prefix";
import { getToken } from "./auth";
import { getApiUrl } from "../config/api";

const makeRequests = basePath => {
  return defaults()
    .on("request", () => {
      store.dispatch(setLoading(true));
    })
    .set("Accept", "application/json")
    .set("X-Requested-With", "XMLHttpRequest")
    .set("X-Client", "front")
    .use(
      intercept((err, resp) => {
        if (!resp) {
          history.push(serverError());
        }

        if (resp.status == 400) {
          if (resp.body.message) {
            log.error(resp.body.message);
          } else {
            log.error("Ошибка ввода данных");
          }
        } else if (resp.status == 401) {
          window.location.href = getPartnerUrl("login", "auto");
        } else if (resp.status == 404) {
          history.push(notFound());
        } else if (resp.status === 500) {
          history.push("/500");
        } else if (resp.status === 503) {
          history.push("/503");
        } else if (!resp.ok) {
          log.error(resp.error);
        }

        store.dispatch(setLoading(false));
      })
    )
    .use(prefix(basePath))
    .on("request", req => {
      req.set("Authorization", `token ${getToken()}`);
    });
};

export const requests = makeRequests(getApiUrl("/v1"));
export const requestsV1 = makeRequests(getApiUrl("/v1"));
export const requestsV2 = makeRequests(getApiUrl("/v2"));
